import React from 'react';

import { SpotlightPulse } from '@atlaskit/onboarding';

import { useDiscoverabilityPulsePostOffice } from './usePostOfficeDiscoverabilityPulse.ts';

type DiscoverabilityPulseProps = {
	children: JSX.Element;
	entryPointId: string;
	isCircle?: boolean;
};

export const DiscoverabilityPulse = ({
	children,
	entryPointId,
	isCircle,
}: DiscoverabilityPulseProps) => {
	const { isPulseActive } = useDiscoverabilityPulsePostOffice(entryPointId);

	if (!isPulseActive) {
		return children;
	}

	return (
		<SpotlightPulse radius={isCircle ? 24 : 3} testId="loom-cross-sell-discoverability-pulse">
			{children}
		</SpotlightPulse>
	);
};
